import { friendlyApiErrorMessage } from 'src/app/services/api-error-notifier.service';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { Subscription } from "rxjs/internal/Subscription";
import { HttpClient } from '@angular/common/http';
import { ApiService } from 'src/app/services/api.service';
import { FilterService } from 'src/app/services/filter.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-chord-chart-card',
    templateUrl: './chord-chart-card.component.html',
    styleUrls: ['./chord-chart-card.component.scss'],
    standalone: false
})
export class WidgetChordChartCardComponent implements OnInit {
  static key = 100830;

  @Input("item") item: any;
  @Input("pageKey") pageKey: any;

  @Output("onSizeChange") onSizeChange = new EventEmitter<any>();
  @ViewChild("ChordChartDiv", { static: true }) ChordChartDiv!: ElementRef;

  config: any;
  data: any;
  reqSubcription: Subscription[] = [];
  dashboardKey: any;
  currentFilterQuery: string = '';

  // Loading and error state
  public isChildPageLoading: boolean = false;
  public error_name: any;

  constructor(
    private filterService: FilterService,
    private route: ActivatedRoute,
    private httpClient: HttpClient,
    private apiService: ApiService,
    private navigationService: NavigationService
  ) {
    this.route.params.subscribe((p: any) => {
      // Query Params
      this.route.queryParams.subscribe((params: any) => {
        let decryptedParams = this.navigationService.decryptData(params);
        this.dashboardKey = decryptedParams["ds_key"];
      });
    });

    this.reqSubcription.push(
      this.filterService.filterQuery.subscribe((query: any) => {
        console.log(`[ChordChartCard] Filter Query Update.`);
        this.loadApiData();
      })
    );
  }

  ngOnInit(): void {
    this.item;

    const observer = new ResizeObserver((e: any) => {
      this.onSizeChange.emit(e[0].contentRect.height);
    });
    observer.observe(this.ChordChartDiv.nativeElement);
    this.loadlineConfig();

    // this.loadApiData();
  }

  loadlineConfig() {
    const cfg = this.item?.['config']
  }

  shouldLoadData(): boolean {
    return this.item.config?.y_axis === "SP_DESCRIPTION";
  }

  loadApiData(params: any = {}) {
    console.log(`[ChordChartCard] loadApiData`);

    // --- Show Spinner ---
    this.isChildPageLoading = true;
    this.error_name = ''; // Clear any previous error

    const apiConfig = this.item.config || {};
    // Use default keys if not present, similar to PixelMap but maybe different defaults?
    // User didn't specify keys, so I'll assume we use the same endpoint logic but maybe different keys or just generic.
    // The user said "get the same http request loading logic".
    // I'll use the same structure.

    // NOTE: The user's request specifically mentioned "I only need this http request if this.item.config == 'SP_DESCRIPTION'".
    // I am assuming the endpoint is the same "pss/get-pss-data" or similar.
    // PixelMap uses "pss/get-pss-data".

    const apiEndpoint = this.item.config?.["widget_endpoint"] || "pss/get-pss-data";
    const category = this.item.config?.["report_typ"] || "S";  // what data we want to focus on: S is sources, J is journey stops, and R is referral statuses

    const commonQuery = {
      ...this.filterService.baseQuery,
      report_typ: category,
      time_cycle: this.filterService.report_type,
      report_key: undefined,
      // client_key: 2001,
      // dashboard_key: "20250915101536",
      // employee_key: "100288",
      // module_key: "100111",
      // page_key: "2025091510153611",
      ...params
    };

    // PixelMap fetches parent and child data. Chord chart likely needs just one set or similar structure.
    // PixelMap: parentApiKey (status_code_lookup_key) and childApiKey (transactions_key).
    // Chord chart usually visualizes intersections of sets.
    // If it's "SP_DESCRIPTION", it might be journey data.
    // I will fetch `childRequest` equivalent which seems to be the main data in PixelMap (transactions).
    // Let's look at PixelMap again. `childRequest` returns `newChildData` which is assigned to `childData` and `loadedData`.
    // `parentRequest` returns `parentRes` assigned to `parentData`.
    // `getData` uses `loadedData` (child) if available.

    // So I will fetch the "transactions" equivalent.

    const childApiKey = Number(apiConfig["api_key"]) ?? 200240; // Default from Chord Chart
    const query = { ...commonQuery, api_key: childApiKey };

    this.httpClient.post<any[]>(
      `${this.apiService.apiBaseUrl}/${apiEndpoint}`,
      query
    ).subscribe({
      next: (res: any[]) => {
        this.data = res || [];
        this.isChildPageLoading = false; // --- Hide Spinner ---
        console.log(`[ChordChartCard] Data loaded:`, this.data.length);
      },
      error: (err) => {
        console.error(`[ChordChartCard] Error loading data:`, err);
        this.data = [];
        this.isChildPageLoading = false; // --- Hide Spinner on error ---
        this.error_name = friendlyApiErrorMessage(err);
      }
    });
  }

  ngOnDestroy(): void {
    this.reqSubcription.forEach((res) => res.unsubscribe());
  }

}
